<template>
  <div>
    <p>
      Um andere Geräte in diesem Raum zu finden musst du Benutzer in deinen
      Raum einladen.
    </p>
    <p>
      Sobald sie der Einladung gefolgt sind und den Raum geöffnet haben,
      sind sie hier sichtbar.
    </p>
  </div>
</template>

<script>
  import {switchRoom} from './step-utils';


  const component = {
    name: 'StepRoomInvite'
  };


  export const StepRoomInvite = {
    target: '.no-peers .v-btn',
    before: async () => {
      await switchRoom('example-room');
    },
    header: 'Benutzer in Raum einladen',
    content: component
  };


  export default component;
</script>
